import { Svg } from "common/assets"
import { TProduct } from './types'
import { IconEllipse, StyledItemProduct, StyledItemProductName, StyledItemProductPrice, StyledNameWrapper, StyledSpan } from "./styled"

export const ProductItem = ({ product }: { product: TProduct }) => {
    return (
        <StyledItemProduct >
            <StyledItemProductName>
                <IconEllipse fill={product.color}>
                    <use href={Svg.sprite + "#icon-ellipse"} />
                </IconEllipse>
                <StyledNameWrapper>{product.name}</StyledNameWrapper>
            </StyledItemProductName>
            <StyledItemProductPrice>
                {product.price}
                <StyledSpan>{product.coins}</StyledSpan>
            </StyledItemProductPrice>
        </StyledItemProduct>
    )
}